// assets/cart-drawer-price-fix.js
// Re-apply visual 0-price for "Free Gift" rows in Cart Drawer
// while keeping quantity controls functional (no observer loop).

(function () {
  const FREE_GIFT_TEXT = "free gift";
  const ZERO_TEXT = "€0,00";

  let observer = null;
  let scheduled = false;

  function rowHasFreeGift(row) {
    const labels = row.querySelectorAll(".discounts__discount");
    for (const el of labels) {
      const txt = (el.textContent || "").toLowerCase();
      if (txt.includes(FREE_GIFT_TEXT)) return true;
    }
    return false;
  }

  function setIfDifferent(el, value) {
    if (!el) return false;
    if (el.textContent !== value) {
      el.textContent = value;
      return true;
    }
    return false;
  }

  function fixRow(row) {
    if (!rowHasFreeGift(row)) return;

    // ---- Unit price under title ----
    const unitFinal = row.querySelector(".cart-item__details .cart-item__final-price");
    const unitOptions = row.querySelectorAll(".cart-item__details .product-option");

    // In your Liquid, the first .product-option is the unit price when not discounted
    if (unitFinal) setIfDifferent(unitFinal, ZERO_TEXT);
/*     if (unitOptions && unitOptions.length > 0) setIfDifferent(unitOptions[0], ZERO_TEXT);
 */
    // ---- Line total right column (current price span) ----
    const totalsCell = row.querySelector(".cart-item__totals");
    if (totalsCell) {
      const finalTotal = totalsCell.querySelector("span.price.price--end");
      if (finalTotal) setIfDifferent(finalTotal, ZERO_TEXT);
    }
  }

  function fixAll() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return;

    const rows = drawer.querySelectorAll("tr.cart-item");
    rows.forEach(fixRow);
  }

  function guardedFixAll() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return;

    // Disconnect while we write textContent so we don't create loops
    if (observer) observer.disconnect();
    try {
      fixAll();
    } finally {
      if (observer) {
        observer.observe(drawer, {
          childList: true,
          subtree: true,
          characterData: false,
          attributes: false,
        });
      }
    }
  }

  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      guardedFixAll();
    });
  }

  function runFixBurst() {
    // Re-run a few times to beat Bold's delayed writes
    scheduleFix();
    setTimeout(scheduleFix, 120);
    setTimeout(scheduleFix, 300);
    setTimeout(scheduleFix, 600);
    setTimeout(scheduleFix, 1000);
    setTimeout(scheduleFix, 1600);
  }

  function init() {
    const drawer = document.querySelector("#CartDrawer");
    if (!drawer) return;

    observer = new MutationObserver(() => {
      // Any re-render (qty changes) -> re-apply once
      scheduleFix();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: false,
      attributes: false,
    });

    runFixBurst();
  }

  document.addEventListener("DOMContentLoaded", init);
})();
